module.exports = __webpack_public_path__ + "static/media/icons for website-03.6a1b5663.svg";